import { render, staticRenderFns } from "./Batchcontrol.vue?vue&type=template&id=3c57a91d&scoped=true&"
import script from "./Batchcontrol.vue?vue&type=script&lang=js&"
export * from "./Batchcontrol.vue?vue&type=script&lang=js&"
import style0 from "./Batchcontrol.vue?vue&type=style&index=0&id=3c57a91d&scoped=true&lang=css&"
import style1 from "./Batchcontrol.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57a91d",
  null
  
)

export default component.exports